import React from 'react'
import './experiences.css'
import { Link } from 'react-router-dom'

const Experiences = ({data}) => {
    // const newdata = data.splice(0,3);
  return (
    <section className='restaurant-lounge'>
      <div className="restaurant-lounge-wrapper">
          <div className="restaurant-lounge-overview">
            <h2>Fun & Relaxation Experiences</h2>
            <p>
              Nestled in the heart of the city, Brand Hotel Dodoma invites you to experience a perfect blend of leisure, dining, and family-friendly fun. Whether you're looking to take a refreshing dip in our sparkling pool, savor delicious meals at our vibrant restaurant, or unwind in our stylish lounge, we have something for everyone. With exciting activities for kids and affordable pricing, Brand Hotel Dodoma is your go-to destination for a memorable day out. 
            </p>
            <Link to="/experiences" className='experiences-link' >Explore more</Link>
          </div>

          <div className="experiences-image">
            {
              data.map((img, index)=>{
                return(
                  <img key={index} src={img} alt="" />
                )
              })
            }
          </div>
      </div>
    </section>
  )
}

export default Experiences